import { Factory } from 'rosie';
import './lib/uuid';

Factory.define('FbMessageIncomingAttachment').extend('Uuid');

Factory.define('FbMessageIncomingAttachmentWithDefaults')
  .extend('FbMessageIncomingAttachment')
  .attr('attachmentId', 'some-id')
  .attr('contentType', 'text/plain')
  .attr('filename', 'some-facebook-attachment.txt')
  .attr('type', 'file');



// WEBPACK FOOTER //
// ./factories/fb_message_incoming_attachment_factory.js